import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navItems = [
    { label: t('navHome'), href: '/' },
    { label: t('navWanghong'), href: '/category/wanghong-fancha' },
    { label: t('navMingxing'), href: '/category/mingxing-tafang' },
    { label: t('navDasai'), href: '/category/meiri-dasai' },
    { label: t('navDujia'), href: '/category/dujia-shoufa' },
    { label: t('navAbout'), href: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              {t('siteName')}
            </span>
            <span className="text-xs md:text-sm font-medium px-2 py-0.5 rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
              {t('hotTag')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                  location.pathname === item.href || location.pathname.startsWith(item.href + '/')
                    ? 'text-primary-500'
                    : 'text-foreground-800'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className="ri-menu-line text-2xl text-foreground-950" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-lg border-t border-background-200/70">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`block py-2 text-base font-medium ${
                  location.pathname === item.href || location.pathname.startsWith(item.href + '/')
                    ? 'text-primary-500'
                    : 'text-foreground-800'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}